import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../common/EnhancedTableHead';
import LinkRouter from '../common/LinkRouter';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import MessageIcon from '@material-ui/icons/ChatBubble';
import { Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    statusIcon: {
      color: theme.palette.text.secondary,
      marginRight: 4,
      fontSize: '1rem'
    },
    statusContainer: { 
      display: 'flex' 
    },
    approvalIconContainer: { 
      display: 'flex', 
      alignItems: 'center', 
      marginRight: 8 
    },
    commentsIconContainer: {
      display: 'flex', 
      alignItems: 'center'
    }
  })
);

interface Props {
  approvals: any[];
}

const headRows: HeadRow[] = [
  { id: 'WorkflowName', disablePadding: true, label: 'Workflow Name' },
  { id: 'FamilyName', disablePadding: false, label: 'Family Name' },
  { id: 'ApprovalRequestCreationTime', disablePadding: false, label: 'Request Creation Date' },
  { id: 'Status', disablePadding: false, label: 'Status' }
];

function ApprovalsTable(props: Props) {
  const classes = useStyles({});
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<string>('familyName');

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const sortedRows = sortRows(props.approvals, getSorting(order, orderBy));

  return (
    <Table>
      <EnhancedTableHead
        order={order}
        orderBy={orderBy}
        fields={headRows}
        onRequestSort={handleRequestSort}
      />
      <TableBody>
        {sortedRows.map(row => (
          <TableRow key={row.GUID}>
            <TableCell component="th" scope="row">
              <LinkRouter variant="body1" to={`/approvals/${row.GUID}`}>{row.WorkflowName}</LinkRouter>
            </TableCell>
            <TableCell>{row.FamilyName}</TableCell>
            <TableCell>{moment(row.ApprovalRequestCreationTime * 1000).format('ddd, MMM Do YYYY, HH:mm z')} {moment.tz.zone(moment.tz.guess()).abbr(row.ApprovalRequestCreationTime * 1000)}</TableCell>
            <TableCell>
              <div className={classes.statusContainer}>
                {row.approvalCounts.approved > 0 && <Tooltip title="Approvals"><div  className={classes.approvalIconContainer}>
                  <ThumbUpIcon className={classes.statusIcon} /><Typography>{row.approvalCounts.approved}</Typography>
                </div></Tooltip>}
                {row.approvalCounts.rejected > 0 && <Tooltip title="Rejections"><div className={classes.approvalIconContainer}>
                  <ThumbDownIcon className={classes.statusIcon} /><Typography>{row.approvalCounts.rejected}</Typography>
                </div></Tooltip>}
                <Tooltip title="Comments"><div className={classes.commentsIconContainer}>
                  <MessageIcon className={classes.statusIcon} /><Typography>{row.Comments.length}</Typography>
                </div></Tooltip>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ApprovalsTable;
